import { Button } from 'components/componentsPresfor';
import React, { useState } from 'react';
import { AiOutlineMenuUnfold } from 'react-icons/ai';
import { Sidebar } from 'react-pro-sidebar';
import { useNavigate } from 'react-router-dom';

const SidebarPresfor = (props) => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <div
        id="mobile-menu-button"
        className="hidden sm:block sm:text-3xl sm:text-black-900 md:block md:text-3xl md:text-black-900 sm:px-4 md:px-4"
      >
        <button onClick={toggleMobileMenu}>
          <AiOutlineMenuUnfold />
        </button>
      </div>

      <div>
        <Sidebar className={isMobileMenuOpen ? 'visible' : 'hidden'}>
          <Button
            className={props?.activeclassIngenieurieSociauxFonciere}
            onClick={() =>
              navigate('/presfor/PSFCPRESFORlivrablesIngenieurieSociaux')
            }
            color={props?.activeclrIngenieurieSociauxFonciere}
            size="sm"
            variant="fill"
          >
            INGÉNIERIE SOCIAUX FONCIÈRE
          </Button>
          <Button
            className={props?.activeclassdelimitation}
            onClick={() =>
              navigate('/presfor/psfcpresforlivrablesdelimitation')
            }
            color={props?.activeclrdelimitation}
            size="sm"
            variant="fill"
          >
            DÉLIMITATION DES TERRITOIRES DE VILLAGES (DTV)
          </Button>
          <Button
            className={props?.activeclasscertification}
            onClick={() => navigate('/presfor/psfcpresforenqcf')}
            color={props?.activeclrcertification}
            size="sm"
            variant="fill"
          >
            CERTIFICATION FONCIERE (CF)
          </Button>
          <Button
            className={props?.activeclassconsolidationdroits}
            onClick={() => navigate('/presfor/psfcpresforconsolidationdroits')}
            color={props?.activeclrconsolidationdroits}
            size="sm"
            variant="fill"
          >
            CONSOLIDATION DES DROITS CONCEDES (CDC)
          </Button>
          <Button
            className={props?.activeclasscontractualisation}
            onClick={() => navigate('/presfor/psfcpresforenqpromocontrat')}
            color={props?.activeclrcontractualisation}
            size="sm"
            variant="fill"
          >
            PROMOTION DE LA CONTRACTUALISATION
          </Button>
          <Button
            className={props?.activeclasscloture}
            onClick={() => navigate('/presfor/psfcpresforlivrablescloture')}
            color={props?.activeclrcloture}
            size="sm"
            variant="fill"
          >
            CLOTURE DES OPERATIONS INTEGREES
          </Button>
        </Sidebar>
      </div>

      <div className={props.wrapperClassName || ''}>
        <Sidebar
          className={`bg-[#f0f8fa} ${
            props.desktopSidebarClassName || props.className
          }`}
        >
          <div
            className={`${props.contentClassName || 'h-screen'} flex flex-col justify-between py-6`}
          >
            <div className="flex-grow flex justify-center bg-[#f0f8fa]">
              <div className="text-center">
                <Button
                  className={props?.activeclassIngenieurieSociauxFonciere}
                  onClick={() => {
                    if (
                      window.location.pathname ===
                        '/psfcpresforenqpromocontratenquetecreee' ||
                      window.location.pathname ===
                        '/psfcpresforlivrablescloture' ||
                      window.location.pathname ===
                        '/psfcpresforenqpromocontrat' ||
                      window.location.pathname ===
                        '/psfcpresforconsolidationdroits' ||
                      window.location.pathname === '/psfcpresforenqcf' ||
                      window.location.pathname ===
                        '/psfcpresforlivrablesdelimitation'
                    ) {
                      // console.log('clicked 2');
                      navigate(
                        '/presfor/PSFCPRESFORlivrablesIngenieurieSociaux'
                      );
                      navigate(0);
                    } else {
                      // console.log('clicked 3');
                      navigate(
                        '/presfor/PSFCPRESFORlivrablesIngenieurieSociaux'
                      );
                      // window.location.reload();
                    }
                  }}
                  color={props?.activeclrIngenieurieSociauxFonciere}
                  size="sm"
                  variant="fill"
                >
                  INGÉNIERIE SOCIAUX FONCIÈRE
                </Button>
                <Button
                  className={props?.activeclassdelimitation}
                  onClick={() =>
                    navigate('/presfor/psfcpresforlivrablesdelimitation')
                  }
                  color={props?.activeclrdelimitation}
                  size="sm"
                  variant="fill"
                >
                  DÉLIMITATION DES TERRITOIRES DE VILLAGES (DTV)
                </Button>

                <Button
                  className={props?.activeclasscertification}
                  onClick={() => navigate('/presfor/psfcpresforenqcf')}
                  color={props?.activeclrcertification}
                  size="sm"
                  variant="fill"
                >
                  CERTIFICATION FONCIERE (CF)
                </Button>
                <Button
                  className={props?.activeclassconsolidationdroits}
                  onClick={() =>
                    navigate('/presfor/psfcpresforconsolidationdroits')
                  }
                  color={props?.activeclrconsolidationdroits}
                  size="sm"
                  variant="fill"
                >
                  CONSOLIDATION DES DROITS CONCEDES (CDC)
                </Button>
                <Button
                  className={props?.activeclasscontractualisation}
                  onClick={() =>
                    navigate('/presfor/psfcpresforenqpromocontrat')
                  }
                  color={props?.activeclrcontractualisation}
                  size="sm"
                  variant="fill"
                >
                  PROMOTION DE LA CONTRACTUALISATION
                </Button>
                <Button
                  className={props?.activeclasscloture}
                  onClick={() =>
                    navigate('/presfor/psfcpresforlivrablescloture')
                  }
                  color={props?.activeclrcloture}
                  size="sm"
                  variant="fill"
                >
                  CLOTURE DES OPERATIONS INTEGREES
                </Button>
              </div>
            </div>
            <div className="flex justify-center mb-4 rounded bg-[#f0f8fa]">
              <img
                src="/images/sidebar.png"
                className="w-[80%] h-[300px] object-contain"
                alt="Sidebar Graphic"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'images/default.png';
                }}
              />
            </div>
          </div>
        </Sidebar>
      </div>
    </>
  );
};

SidebarPresfor.defaultProps = {
  activeclrIngenieurieSociauxFonciere: 'cyan_900_19',
  activeclrsensibilisation: 'cyan_900_19',
  activeclrconsolidationdispositifs: 'cyan_900_19',
  activeclrdelimitation: 'cyan_900_19',
  activeclrcertification: 'cyan_900_19',
  activeclrconsolidationdroits: 'cyan_900_19',
  activeclrcontractualisation: 'cyan_900_19',
  activeclrcloture: 'cyan_900_19',
  activeclassIngenieurieSociauxFonciere:
    'common-pointer !text-black-900_b2 cursor-pointer font-inter leading-[normal] mt-2.5 mx-auto rounded-sm text-center text-xs w-[223px] !hover:text-white',
  activeclasssensibilisation:
    'common-pointer !text-black-900_b2 cursor-pointer font-inter leading-[normal] mt-2.5 mx-auto rounded-sm text-center text-xs w-[223px] !hover:text-white',
  activeclassconsolidationdispositifs:
    'common-pointer !text-black-900_b2 cursor-pointer font-inter leading-[normal] mt-2.5 mx-auto rounded-sm text-center text-xs w-[223px] !hover:text-white',
  activeclassdelimitation:
    'common-pointer !text-black-900_b2 cursor-pointer font-inter leading-[normal] mt-2.5 mx-auto rounded-sm text-center text-xs w-[223px] !hover:text-white',
  activeclasscertification:
    'common-pointer !text-black-900_b2 cursor-pointer font-inter leading-[normal] mt-2.5 mx-auto rounded-sm text-center text-xs w-[223px] !hover:text-white',
  activeclassconsolidationdroits:
    'common-pointer !text-black-900_b2 cursor-pointer font-inter leading-[normal] mt-2.5 mx-auto rounded-sm text-center text-xs w-[223px] !hover:text-white',
  activeclasscontractualisation:
    'common-pointer !text-black-900_b2 cursor-pointer font-inter leading-[normal] mt-2.5 mx-auto rounded-sm text-center text-xs w-[223px] !hover:text-white',
  activeclasscloture:
    'common-pointer !text-black-900_b2 cursor-pointer font-inter leading-[normal] mt-2.5 mx-auto rounded-sm text-center text-xs w-[223px] !hover:text-white',
};

export default SidebarPresfor;
